/**
 * Duty-status helpers shared by the personnel list and the personnel edit form.
 *
 * The 是否為值班人員 switch now lives in two places -- the table row (quick
 * toggle) and the edit form -- so the switch's labels live here to keep the two
 * from drifting apart, and the state transition lives here so it can be unit
 * tested without mounting the modal.
 */

/**
 * Give the row toggle a deadline. The app sets no global axios timeout, so a
 * request that never answers would otherwise leave the row disabled forever
 * while it displays a value that was never saved -- the one failure mode an
 * optimistic switch cannot show honestly. On timeout the request rejects and
 * the normal rollback path runs.
 */
export const DUTY_TOGGLE_TIMEOUT_MS = 15000;

/** Props shared by every 是否為值班人員 switch, so both render identically. */
export const DUTY_SWITCH_LABELS = {
  checkedChildren: "是",
  unCheckedChildren: "否",
};

/** Personnel rows arrive as 1/0 from the API and as true/false from the form. */
export const isOnDuty = (record) =>
  record?.onDuty === 1 || record?.onDuty === true;

/**
 * Return a new personnel list with one row's duty flag replaced.
 *
 * Never mutates `list` or any row in it: the toggled row is replaced by a copy
 * so an optimistic update can be rolled back to the previous array as-is.
 */
export const setOnDutyById = (list, id, onDuty) => {
  if (!Array.isArray(list)) {
    return [];
  }
  return list.map((item) =>
    item?.id === id ? { ...item, onDuty } : item
  );
};

/** Toast text for a completed toggle, e.g. 「王小明」已設為值班人員. */
export const dutyChangeMessage = (name, onDuty) =>
  `「${name}」已設為${onDuty ? "值班人員" : "非值班人員"}`;
